import { ChartOptions } from "chart.js";

type TooltipTitleFunction = (tooltipItems: any[]) => string | string[];
type TooltipLabelFunction = (tooltipItem: any) => string | string[] | null;

const getChartOptions = (titleFunc: TooltipTitleFunction, labelFunc?: TooltipLabelFunction) => {
  return {
    showOutline: false,
    showGraticule: false,
    plugins: {
      tooltip: {
        callbacks: {
          title: titleFunc,
          label: labelFunc,
        },
        displayColors: false,
        titleFont: {size: 13}
      },
      legend: {
        display: false,
      },
    },
    scales: {
      projection: {
        axis: "x",
        projection: "mercator"
      },
      color: {
        axis: "x",
        display: false,
      },
    },
  } as ChartOptions;
}

export default getChartOptions;